import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceUserAccess from '../../space-user-access'

export const RESOURCE = {
  payload: {
    description: 'Survey Admins and Standard User assignments to Organizations',
    dimension: spaceUserAccess.RESOURCE.payload,
    level: 0,
    name: 'Space User Access Assignments',
    partialId: PartialId.Standard.create('entry'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
